
// src/utils/checagens.ts

export const CAPTACAO_STATUS = {
  captado_exclusivo: 'Captado (Exclusivo)',
  captado_nao_exclusivo: 'Captado (Não Exclusivo)',
  sem_interesse: 'Sem Interesse',
  locacao: 'Locação',
  nao_iniciada: 'Não Iniciada',
  em_negociacao: 'Em Negociação',
  recusado: 'Recusado',
};

export type CaptacaoStatus = keyof typeof CAPTACAO_STATUS;
